<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="documentName"
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'

const emit = defineEmits(['sortChanged', 'loadMore', 'details'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'documentName', label: 'name', sortable: false },
    { key: 'frequencyName', label: 'frequency', sortable: false,thStyle:'width:20vh'}
])

const actionButtons = ref([])


</script>
